// src/components/black-friday/account-selector.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { Check, Plus, ChevronDown, Users } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useBFAccounts } from "@/contexts/black-friday-account-context";

export default function BFAccountSelector() {
  const navigate = useNavigate();
  const { accounts, currentAccount, switchAccount } = useBFAccounts();

  if (accounts.length === 0) {
    return null;
  }

  const handleAddAccount = () => {
    navigate("/bf/settings");
  };

  const handleSwitchAccount = (accountId: string) => {
    switchAccount(accountId);
  };

  const displayName = currentAccount?.accountName || accounts[0]?.accountName || "Select Account";
  const accountCount = accounts.length;

  return (
    <div className="flex items-center">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            size="lg"
            className="font-semibold min-w-[288px] text-lg flex items-center justify-between gap-2 hover:bg-accent"
          >
            <span className="truncate">{displayName}</span>
            <ChevronDown className="w-5 h-5 opacity-50 flex-shrink-0" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="center" className="w-64">
          <DropdownMenuLabel className="flex items-center justify-between">
            <span>Black Friday Accounts</span>
            <span className="text-xs text-muted-foreground font-normal">{accountCount} total</span>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          {accounts.map((account) => (
            <DropdownMenuItem
              key={account.id}
              onClick={() => handleSwitchAccount(account.id)}
              className="flex items-center justify-between cursor-pointer"
            >
              <span className="truncate">{account.accountName}</span>
              {currentAccount?.id === account.id && (
                <Check className="w-4 h-4 ml-2 flex-shrink-0 text-green-600" />
              )}
            </DropdownMenuItem>
          ))}
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={handleAddAccount}
            className="flex items-center cursor-pointer text-blue-600 dark:text-blue-400 font-medium"
          >
            <Plus className="w-4 h-4 mr-2" />
            Add Another Account
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
